/* global axios */
import ApiClient from '../ApiClient';

class KnowledgeBaseAPI extends ApiClient {
  constructor() {
    super('knowledge_base', { accountScoped: true });
  }

  getPortals() {
    return axios.get(`${this.url}/portals`);
  }

  getArticles({ page, locale, query, portalId } = {}) {
    const params = new URLSearchParams();
    if (page) params.set('page', page);
    if (locale) params.set('locale', locale);
    if (query) params.set('query', query);
    if (portalId) params.set('portal_id', portalId);

    const qs = params.toString();
    return axios.get(`${this.url}/articles${qs ? `?${qs}` : ''}`);
  }

  getArticle({ id }) {
    return axios.get(`${this.url}/articles/${id}`);
  }
}

export default new KnowledgeBaseAPI();
